// extracted by mini-css-extract-plugin
module.exports = {"container":"StoryLinks_container__QLAze","button":"StoryLinks_button__c7DtI","icon":"StoryLinks_icon__wylM7","scrollToTop":"StoryLinks_scrollToTop__A0c5Z"};